import React, { useEffect, useState } from 'react';
import { Button, List, Row, Col, Spin, Alert, Typography } from 'antd';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom'
import moment from 'moment';

const UserTopDetailPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);

  const startDate = queryParams.get('startDate');
  const endDate = queryParams.get('endDate');
  const search = queryParams.get('search');


  const [data, setData] = useState<any>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(`/api/transfers/users-tops-detail`, {
          params: { 
            search: search, 
            page: currentPage, 
            limit: pageSize,
            startDate: startDate, 
            endDate: endDate
          }
        });
        
        if (response.data && response.data.docs) {
          setData(response.data.docs);
          setTotal(response.data.totalDocs || 0);
        } else {
          setData([]);
          setTotal(0);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setError('Không thể tải dữ liệu. Vui lòng thử lại.');
        setData([]);
        setTotal(0);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [search, currentPage, pageSize, startDate, endDate]);

  const handlePaginationChange = (page: number, pageSize?: number) => {
    setCurrentPage(page);
    if (pageSize) {
      setPageSize(pageSize);
    }
  };

  const formatDateTime = (dateString: string) => {
    return moment(dateString).format('DD/MM/YYYY HH:mm:ss');
  };

  return (
    <>
      <Typography.Title level={2}>Chi Tiết Top Users</Typography.Title>
      <div style={{ marginBottom: "16px" }}>
        <Button onClick={() => navigate(`/users/top${location.search}`)}>Quay Lại</Button>
      </div>
      
      {error && (
        <Alert
          message="Lỗi"
          description={error}
          type="error"
          showIcon
          style={{ marginBottom: "16px" }}
        />
      )}
      
      <Spin spinning={loading}>
        <List
          header={<Row style={{ width: '100%' }}>
            <Col span={6}><strong>Ngày Giờ</strong></Col>
            <Col span={4}><strong>Người Gửi</strong></Col>
            <Col span={4}><strong>Người Nhận</strong></Col>
            <Col span={4}><strong>Số Sao Nhận</strong></Col>
            <Col span={6}><strong>Nội Dung</strong></Col>
          </Row>}
          bordered
          dataSource={data}
          renderItem={(item: { senderName: string; receiverName: string; comment: string; value: string; date: string; }) => (
            <List.Item>
              <Row style={{ width: '100%' }}>
                <Col span={6}>{formatDateTime(item.date)}</Col>
                <Col span={4}>{item.senderName}</Col>
                <Col span={4}>{item.receiverName}</Col>
                <Col span={4}>{item.value}</Col>
                <Col span={6}>{item.comment}</Col>
              </Row>
            </List.Item>
          )}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: total,
            onChange: handlePaginationChange,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total, range) => `${range[0]}-${range[1]} của ${total} mục`,
          }} 
        />
      </Spin>
    </>
  );
};

export default UserTopDetailPage;